(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["in-the-news"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('news-carousel')) {
    class NewsCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-news-track]');
        this.prev = this.querySelector('[data-news-prev]');
        this.next = this.querySelector('[data-news-next]');
        if (!this.track || !this.prev || !this.next) return;

        this.onPrev = () => this.scrollByCard(-1);
        this.onNext = () => this.scrollByCard(1);
        this.onScroll = () => this.updateButtons();

        this.prev.addEventListener('click', this.onPrev);
        this.next.addEventListener('click', this.onNext);
        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        this.resizeObserver = new ResizeObserver(this.onScroll);
        this.resizeObserver.observe(this.track);
        this.updateButtons();
      }

      disconnectedCallback() {
        this.prev?.removeEventListener('click', this.onPrev);
        this.next?.removeEventListener('click', this.onNext);
        this.track?.removeEventListener('scroll', this.onScroll);
        this.resizeObserver?.disconnect();
      }

      scrollByCard(direction) {
        const item = this.track.querySelector('.in-the-news__item');
        if (!item) return;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        this.track.scrollBy({ left: direction * (item.offsetWidth + gap), behavior: 'smooth' });
      }

      updateButtons() {
        const { scrollLeft, scrollWidth, clientWidth } = this.track;
        this.prev.disabled = scrollLeft <= 1;
        this.next.disabled = scrollLeft + clientWidth >= scrollWidth - 1;
      }
    }

    customElements.define('news-carousel', NewsCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
